var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1488 24.9986C9.51812 23.5809 9.1665 22.0038 9.1665 20.3418C9.1665 14.1692 14.0168 9.16528 19.9998 9.16528C25.983 9.16528 30.8332 14.1692 30.8332 20.3418C30.8332 22.0038 30.4815 23.5809 29.8508 24.9986",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33203V4.9987",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 19.9988H35",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 19.9988H3.3335",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.784 8.21313L30.6055 9.39165",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39483 9.39336L8.21631 8.21484",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1948 32.176C25.8788 31.6314 26.5542 30.09 26.7442 28.5397C26.8008 28.0765 26.4198 27.6924 25.9532 27.6924L14.1279 27.6927C13.6453 27.6927 13.2576 28.1024 13.3153 28.5815C13.5013 30.1289 13.971 31.2592 15.7556 32.176M24.1948 32.176C24.1948 32.176 16.0494 32.176 15.7556 32.176M24.1948 32.176C23.9923 35.4177 23.0562 36.7015 20.0112 36.6655C16.7542 36.7257 16.0049 35.1389 15.7556 32.176",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.f3b8eea544367d06b39c647f9a6713e7.svg";
export { ForwardRef as ReactComponent };